import styled from 'styled-components';
import { RouterLink } from '@redux-first-router-link';
export const SearchResultLink = styled(RouterLink)`
  text-decoration: none;
`;
export const ClickableNonLink = styled('div')`
  cursor: pointer;
`;
